import { getTranslatedString } from 'helpers/i18n';

export const parseErrorCode = errorCode => {
  let translatedErrorMessage = getTranslatedString('tenantPortal.paysafe.paymentFailure');

  translatedErrorMessage = getTranslatedString(
    `tenantPortal.paysafe.paymentFailure.${errorCode}`,
    null,
    translatedErrorMessage
  );

  return translatedErrorMessage;
};
